<template>

	<div class="container main-content">
		<div class="row">
			<div class="col-12">
				<div class="row mb-5">
					<div class="col-12 col-md-6 offset-md-3 text-center mt-5">
						<h4 class="dark-highlight mb-4">Photo verification required</h4>
						<p>You're almost set!  You'll need to provide a photo of yourself to complete the verification process.</p>
					</div>
				</div>
			</div>
		</div>
		<div class="row">
			<div class="col-12 text-center">
				<p class="mb-3">
				<a href="#" class="btn next-btn" v-on:click.prevent="doCamera">Camera</a>
				</p>
				<p>
				<small><a href="#" class="" v-on:click.prevent="doUpload">Don't have a camera?  Upload your picture here.</a></small>
				</p>
			</div>
		</div>
	</div>

</template>

<script>


export default {
	
	data() {
		return {
			
		}
	},
	methods: {
		doUpload() {
			this.$router.push('image-input-upload');
		},
		doCamera() {
			this.$router.push('image-input-camera');
		}
	}
}
</script>
